var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? [
            _vm.hourformat === "24"
              ? _c("el-time-select", {
                  ref: _vm.reference,
                  attrs: {
                    placeholder: _vm.$t.__("common.labels.hour"),
                    "picker-options": _vm.selectOptions
                  },
                  model: {
                    value: _vm.currentValue,
                    callback: function($$v) {
                      _vm.currentValue = $$v
                    },
                    expression: "currentValue"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hourformat === "12"
              ? _c("el-time-picker", {
                  ref: _vm.reference,
                  attrs: {
                    placeholder: _vm.$t.__("common.labels.hour"),
                    "value-format": "HH:mm A",
                    format: "HH:mm A",
                    "picker-options": _vm.pickerOptions
                  },
                  model: {
                    value: _vm.currentValue,
                    callback: function($$v) {
                      _vm.currentValue = $$v
                    },
                    expression: "currentValue"
                  }
                })
              : _vm._e()
          ]
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.currentValue) + "\n    ")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }